import DeleteFile from './deleteFile.js';
import ImportFile from './importFile.js';
import PreviewFile from './previewFile.js';

class StoreSidebar {
  get dom() {
    return {
      SELECTS: '.select2select',
      DELETE_FILE: '.delete-file-button',
      PREVIEW_FILE: '.preview-file',
      FILE_TO_PREVIEW: '.file-to-preview',
      SITE_IMPORT_BTN: '.site-import-btn',
      RTS_IMPORT_BTN: '#rts-import-btn',
    };
  }

  constructor(storeId = false) {
    this.$el = $('.sidebar-content');
    this.storeId = storeId;
    this._checkByXmlFiles();
    this.deleteFile = new DeleteFile(this.storeId);
    this.importFile = new ImportFile();
    this.previewFile = new PreviewFile();
    this.deleteFile.registerConfirmationModal('rts', (file) => {
      let msg = `Are you sure you want to delete file <b>${file}</b>?<br />`;

      if (!ImpactedNodesByRTS.length && !ImpactedServersByRTS.length) {
        return msg + 'No nodes will be impacted by the change';
      }

      if (ImpactedNodesByRTS.length) {
        msg +=
          ' These nodes will be impacted by the change: <ul class="impacted-nodes-list">';
        for (let node of ImpactedNodesByRTS) {
          msg += `<li>${node.hostname}</li>`;
        }
        msg += '</ul>';
      }

      if (ImpactedServersByRTS.length) {
        msg +=
          ' These servers will be impacted by the change: <ul class="impacted-nodes-list">';
        for (let server of ImpactedServersByRTS) {
          msg += `<li>${server.hostname}</li>`;
        }
        msg += '</ul>';
      }

      return msg;
    });

    this.listen();
    this.$el.find('.select2-container').remove();
    $(this.dom.SELECTS).select2();
  }

  listen() {
    $(this.dom.DELETE_FILE).on('click', (e) => this._deleteXMLFile(e));
    $(this.dom.SITE_IMPORT_BTN).on('click', (e) =>
      this.importFile.showImportModal(e),
    );
    $(this.dom.RTS_IMPORT_BTN).on('click', (e) =>
      this.importFile.showRTSImportModal(e),
    );
    $(this.dom.PREVIEW_FILE).on('click', (e) =>
      this.previewFile.showXMLModal(e),
    );
    $(this.dom.FILE_TO_PREVIEW).on('change', (e) =>
      this._updatePreviewButton(e),
    );
    $(this.dom.FILE_TO_PREVIEW).trigger('change');
  }

  destroy() {
    this.deleteFile.removeModalListener();
  }

  _deleteXMLFile(e) {
    e.target.blur();
    this.deleteFile.delete(e);
  }

  _checkByXmlFiles() {
    this.has_xml_files = true; // eslint-disable-line camelcase
    if (!$(this.dom.SELECTS + ' option').length > 0) {
      $(this.dom.STORE_FILE_SHOW_BUTTON).attr('disabled', true);
      $(this.dom.SELECTS).attr('disabled', true);
      this.has_xml_files = false; // eslint-disable-line camelcase
    }
  }

  _updatePreviewButton(e) {
    this.deleteFile.setSelectedFile(e.target);

    if (e.target.getAttribute('rel') == 'store') {
      this.deleteFile.updateDeleteButton(e.target);
    }
  }
}

module.exports = StoreSidebar;
